/* global Waypoint */
import { Component } from '@verndale/core';
import Menu from '../components/Menu';

class UserLocale extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $trigger: this.$el.find('.user-locale'),
      $modal: this.$el.find('.user-locale__modal'),
      $close: this.$el.find('.user-locale__modal-close'),
      $menu: this.$el.find('.user-locale__modal-menu'),
      $menuOption: this.$el.find('.user-locale__modal-menu .menu__link')
    };
    new Menu(this.dom.$menu);
  }

  addListeners() {
    this.dom.$trigger.on('click', ::this.handleOpen);
    this.dom.$close.on('click', ::this.handleClose);
    this.dom.$menuOption.on('click', ::this.handleOptionClick);
  }

  handleOpen(e) {
    e.preventDefault();
    $('body').addClass('body--user-locale');
  }

  handleClose() {
    $('body').removeClass('body--user-locale');
  }

  handleOptionClick(e) {
    e.preventDefault();

    const sHostname = $(e.target).attr('href');
    const { protocol, pathname, search } = document.location;

    document.location.href = `${protocol}//${sHostname}${pathname}${search}`;
  }
}
export default UserLocale;
